import { useContext } from 'react';
import ApplicationContext from '../ApplicationContext';
import { SuntekSettings } from '../ifmsTypes';

export default function useSuntekSettings():SuntekSettings {
  const appContext = useContext(ApplicationContext);
  
  const fromSettings = appContext?.suntekSettings ? appContext.suntekSettings : {};

  return fromSettings;
}